import * as types from "../actions/types";

/**
 * Начальное состояние редуктора для списка типов актов.
 * @type {{list: null, loading: boolean}}
 */
const initialState = {
  list: null,
  loading: false
};

/**
 * Редуктор для списка типов актов.
 * @param {object} state - Текущее состояние.
 * @param {object} action - Действие, которое необходимо выполнить.
 * @returns {object} Новое состояние.
 */
export default function act_types (state = initialState, action) {
  switch (action.type) {
    /**
     * Обрабатывает действие для установки списка типов актов.
     * @returns {object} Новое состояние с обновленным списком.
     */
    case types.SET_ACT_TYPES_LIST:
      return {
        ...state,
        list: action.payload
      };

    /**
     * Обрабатывает действие для установки статуса загрузки.
     * @returns {object} Новое состояние с обновленным статусом загрузки.
     */
    case types.SET_ACT_TYPES_LOADING:
      return {
        ...state,
        loading: action.payload
        
      };
    default:
      return state;
  }
}